import { useSelector } from "react-redux"

/**
 * TEMP feature gate for the "Breakdown by Country" and "Chargeback Olympics" blocks.
 *
 * Applies to the Shopify data source only. Backed by the `hide_health_country_olympics`
 * config variable in Django admin (Admin panel -> Config variables), delivered to the FE
 * as `hide_country_olympics` inside the Health `main-info` response. Admins always keep
 * full access.
 *
 * To remove the whole feature gate: delete this file and its usages
 * (grep for `useCountryOlympicsLocked` and `hide_country_olympics`).
 */
export const useCountryOlympicsLocked = () => {
  const isAdmin = useSelector((state) => state.auth.isAdmin)
  const dataSource = useSelector((state) => state.health.dataSource)
  const { hide_country_olympics } = useSelector((state) => state.health.mainInfo)

  if (isAdmin || dataSource !== "shopify") return false

  // Fail-closed: stay locked until the backend explicitly says the gate is off,
  // so an unresolved `main-info` never exposes the blocks or the subpages.
  return hide_country_olympics !== false
}
